import { RouteObject } from "react-router-dom";
import SampleLayout from "../components/layouts/layoutSample";
import Authenticated from "../../../utils/Authenticated";
import pathRoutes from "../../../routes/pathRoutes";
import EditSample from "../editSample";
import ConditioningSample from "../conditioningSample";
import ConditioningLayout from "../components/layouts/layoutConditioning";
import SampleList from "../sample";
import { PrivateRoutes } from "@app/utils/PrivateRoutes";
import { RolesTypes } from "@app/pages/users/utils/helpers";

const routesSample: RouteObject = {
  path: pathRoutes.PORTAL_SAMPLES,
  children: [
    {
      path: "",
      element: <SampleLayout />,
      children: [
        {
          index: true,
          element: (
            <Authenticated>
              <SampleList />
            </Authenticated>
          ),
        },
        {
          path: "crear",
          element: (
            <PrivateRoutes
              permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
            >
              <Authenticated>
                <EditSample />
              </Authenticated>
            </PrivateRoutes>
          ),
        },
        {
          path: "editar/:id",
          element: (
            <PrivateRoutes
              permissions={[
                RolesTypes.ADMIN,
                RolesTypes.SUPER_ADMIN,
                RolesTypes.TECHNICAL,
              ]}
            >
              <Authenticated>
                <EditSample />
              </Authenticated>
            </PrivateRoutes>
          ),
        },
        {
          path: "analisis/:idMuestra",
          element: <ConditioningLayout />,
          children: [
            {
              index: true,
              element: (
                <Authenticated>
                  <ConditioningSample />
                </Authenticated>
              ),
            },
          ],
        },
      ],
    },
  ],
};

export default routesSample;
